import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { Modal } from "antd";
import { useQuery, useQueryClient } from "react-query";
import Tooltip from "@mui/material/Tooltip";

import _ from "../../../i18n";
import { getUserRoleDelegations } from "../../../api";
import styles from "./UserRoleModal.module.scss";
import IconInfo from "../../common/icons/IconInfo";

const UserRoleModal = ({
  modalOpen,
  closeModal,
  user,
  firstName,
  lastName,
  email,
}) => {
  const auth = useSelector((state) => state.auth);
  const { token } = auth;
  const fiduciary = useSelector((state) => state.folder.fiduciary);

  let { isLoading, data } = useQuery(
    ["userRoles", token, user, modalOpen],
    async () => {
      if (token && modalOpen && user) {
        const response = await getUserRoleDelegations({
          token,
          userId: user.id,
        });

        return response.data.data;
      }
    }
  );

  return (
    <>
      <Modal
        width="70vw"
        height="50vh"
        closable={false}
        open={modalOpen}
        footer={null}
        onCancel={(e) => {
          e.stopPropagation();
          closeModal();
        }}
        maskClosable={false}
        destroyOnClose={true}
        keyboard={false}
      >
        <div className={styles.modal_header}>
          Délégations & rôles:{" "}
          {user && firstName + " " + lastName + " (" + email + ")"}
        </div>
        <div
          className={styles.modal_close}
          onClick={(e) => {
            e.stopPropagation();
            closeModal();
          }}
        >
          <i className="icon-ttp-close"></i>
        </div>

        <div className={styles.modal_body}>
          {isLoading && <div className="lmask"></div>}

          <div className="grid-x grid-margin-x">
            <div className="cell small-12 medium-6">
              <h3 className={styles.title}>
                Délégations{" "}
                <Tooltip title="Délégations" arrow>
                  <span style={{ cursor: "pointer", marginLeft: "5px" }}>
                    <IconInfo />
                  </span>
                </Tooltip>
              </h3>

              {data?.delegations && (
                <ul className={styles.item_box}>
                  {data.delegations.map((i) => (
                    <li key={`del-${i.id}`} className={styles.item_row}>
                      {i.organization.name}
                      <br />
                      {i.organization.uen || "-"}
                      <br />
                      {i.delegationType}
                    </li>
                  ))}
                </ul>
              )}
            </div>
            <div className="cell small-12 medium-6">
              <h3 className={styles.title}>
                Rôles{" "}
                <Tooltip title="Roles" arrow>
                  <span style={{ cursor: "pointer", marginLeft: "5px" }}>
                    <IconInfo />
                  </span>
                </Tooltip>
              </h3>
              {data?.roles && (
                <ul>
                  {data.roles.map((i) => (
                    <li key={`role-${i.id}`} className={styles.item_row}>
                      {i.organization.name}
                      <br />
                      {i.organization.uen}
                      <br />
                      {i.roleType === "LEGAL_REPRESENTATIVE"
                        ? i.roleType + " - " + i.typeStatus
                        : i.roleType === "MANAGER"
                          ? "Admin"
                          : _(i.roleType)}
                    </li>
                  ))}
                </ul>
              )}
            </div>
          </div>
        </div>
      </Modal>
    </>
  );
};

export default UserRoleModal;
